module.exports = __webpack_public_path__ + "static/img/info_big_title.111c124.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/info_big_title.png
// module id = kyew
// module chunks = 4